import { createFeatureSelector, createSelector } from '@ngrx/store';
import * as fromServiceItem from './service-item.reducer';

export const selectServiceItemState =
    createFeatureSelector<fromServiceItem.State>(
        fromServiceItem.serviceItemsFeatureKey
    );

export const { selectIds, selectEntities, selectAll, selectTotal } =
    fromServiceItem.adapter.getSelectors(selectServiceItemState);

export const selectServiceItemPostingTypes = createSelector(
    selectServiceItemState,
    (state: fromServiceItem.State) => state.ServiceItemPostingTypes
);
